import {APPROVAL_STATUS} from '../../../../../constants';
import {hasNewApprovalStatuses} from '../../../../shared/util/ApprovalStatusUtil';

// Overrides only the approval/retainer-period lock (lockedInPeriod → inLockedPeriodWeek /
// inLockedPeriod) so the employee can correct and resubmit a DECLINED time reg.
// The company time-lock (lockedDate → lockedInTime / dayLockedInTime) and the invoice lock
// (invoicedWeek / invoiced) are separate OR-conditions in isDisabled and are NOT bypassed here.
export const isDeclinedAndUnlocked = approvalStatus => hasNewApprovalStatuses() && approvalStatus === APPROVAL_STATUS.DECLINED;
